// extracted by mini-css-extract-plugin
export var fly = "calendar-module--fly--0989f";
export var host = "calendar-module--host--79307";
export var icons = "calendar-module--icons--774f2";
export var location = "calendar-module--location--85d60";
export var organizer = "calendar-module--organizer--277c0";
export var speaker = "calendar-module--speaker--dde55";